import React, { Component,useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar';
import CommonAlert from '../common/Commonalert';

const Freecodeedit =()=>
{
  
  const [Freecode,setFreeCode] = useState([]);
  const [prevFreecode,setPrevFreecode] = useState([]);
  const [freecodeList,setFreecodeList] = useState([]);
  const [errmessage, setErrMessage] = useState({});
  const [freecodeStatus,setFreecodeStatus] = useState([]);
 const [isLoading, setIsLoading] = useState(true); 
 const [alertPopup,setAlertPopup] = useState(false);
   const [alertMessage,setAlertMessage] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
     const [enableAddToCart, setEnableAddToCart] = useState([]);
     const [maxProductsAllowed, setMaxProductsAllowed] = useState(0);
  const [groupedProducts, setGroupedProducts] = useState({
        pizza: [],
        pasta: [],
        burrito: [],
        desserts: []
    });
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [allProducts, setAllProducts]= useState([]);
  const params = useParams();
 

 if(!sessionStorage.getItem("isLoggedIn")){
    window.location.href = '/';
}
if(JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_foodsolutions'))
    {
      window.location.href = '/unauthorized';
    }
const routeChange = (e) =>{ 
    e.preventDefault();
    window.location.href='/freesample/freecode';
}
useEffect(() => {
    // Fetch free code data
    let URL = BaseUrl + `admin/freecode/${params.id}`;
    http.get(URL).then((response) => {
        const data = response.data.data[0];
        setFreeCode(data.Code);
        setPrevFreecode(data.Code);
        setSelectedCategories(data.selectedCategories);
        setEnableAddToCart(data.enableAddToCart);
        setMaxProductsAllowed(data.NumberofProductsallowed);
        setSelectedProducts(data.selectedProducts || []); // Prefill selected products
        setIsLoading(false);
    }).catch((err) => {
        console.log(err);
        setIsLoading(false);
    });

    // Fetch all products
    getAllProducts();
    // Fetch the list of free codes
    getFreecodelist();
}, []);

const getAllProducts = () => {
    const priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    
    http.get(URL).then((response) => {
        const products = response.data.data;
        setAllProducts(products);
        const grouped = groupProductsByCategory(products);
        setGroupedProducts(grouped);
    }).catch((err) => {
        console.log(err);
    });
};

// Group products by category (pizza, pasta, burrito)
const groupProductsByCategory = (products) => {
    const categoryMap = {
        pizza: ["1"],
        pasta: ["10", "13"],
        burrito: ["11", "12"],
        desserts: ["14"]
    };
    const groupedProducts = {
        pizza: [],
        pasta: [],
        burrito: [],
        desserts: []
    };

    products.forEach((product) => {
        Object.keys(categoryMap).forEach((category) => {
            if (categoryMap[category].includes(product.categoryId)) {
                groupedProducts[category].push(product);
            }
        });
    });

    return groupedProducts;
};

const getFreecodelist=()=> {

    let URL = BaseUrl + "admin/freecodelist";
    http.get(URL).then((response) => {
        setFreecodeList(response.data.data);
        
    }).catch((err) => {
        console.log(err);
    })
}


  const submitButton = (e) => {

    e.preventDefault();
    const isValid = formvalidation();

    if(isValid){

        if(prevFreecode != Freecode.trim())
            {
       
            var isFound = freecodeList.some(element => {
               if (element.Code === Freecode.trim()) {
                 return true;
               }
           
               return false;
             });
            }
            else{
       
               var isFound = false;
            }

            if(isFound)
                {
                    setAlertPopup(true);
                    setAlertMessage('This Code has already been added'); 
                  }
                  else
                  {
                            let URL = BaseUrl +`admin/editfreecode/${params.id}`;
                            const payload = {
                                    codeid:params.id,
                                    Code: Freecode.trim(),
                                    selectedCategories:selectedCategories,
                                    selectedProducts:selectedProducts,
                                    enableAddToCart:enableAddToCart,
                                    NumberofProductsallowed: parseInt(maxProductsAllowed)
                                };
                    
                                http.put(URL,payload).then((response)=>{   
                            
                                if (response.data.success === true) {
                                    setAlertPopup(true);
                                    setAlertMessage('Code has been updated successfully'); 
                                }
                    
                            }).catch((error)=>{
                    
                    
                            
                            console.log(error)
                        
                            });
                    }

    }
  
}

const formvalidation = () =>
{
    
    const errmessage = {};
    let isValid = true;
    
    if(Freecode == '' )
    {
        errmessage.freecodeerr = "Code is Required";
        isValid = false;
    }
    else if(Freecode.length < 5 )
    {
        errmessage.freecodeerr = "Incorrect Account Code. Please try again.";
        isValid = false; 
    }

    if (selectedCategories.length === 0) {
        errmessage.categoryErr = "At least one category must be selected.";
        isValid = false;
    }

    setErrMessage(errmessage);
    return isValid;
}

   const handleChange = (e) => {
        if(e.target.name == 'Freecode')
        {
            setFreeCode(e.target.value);
        }
        
};

const handleCategoryChange = (category) => {
    setSelectedCategories((prev) => {
        const newCategories = prev.includes(category)
            ? prev.filter((item) => item !== category)
            : [...prev, category];
        if (!newCategories.includes(category)) {
            // If unchecked, remove the products
            setSelectedProducts((prevSelected) => {
                const productsToRemove = groupedProducts[category]
                    ?.filter((product) => product.PDP_Status === "activate")
                    .map((product) => product.productNumber);
                return prevSelected.filter((productNumber) => !productsToRemove.includes(productNumber));
            });
        } else {
           
            setSelectedProducts((prevSelected) => {
                const activeProducts = groupedProducts[category]
                    ?.filter((product) => product.PDP_Status === "activate") 
                    .map((product) => product.productNumber);
                const updatedSelection = [...prevSelected, ...activeProducts];
                return [...new Set(updatedSelection)];
            });
        }
        return newCategories;
    });
};

  const handleEnableAddToCart = (category) => {
    setEnableAddToCart((prev) =>
        prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
};
const handleProductToggle = (productNumber) => {
    setSelectedProducts(prevSelected => {
        if (prevSelected.includes(productNumber)) {
            return prevSelected.filter(num => num !== productNumber);
        } else {
            return [...prevSelected, productNumber];
        }
    });
};
const accObjectiveoptions = Array.from({ length: 100 }, (_, i) => i)
  return (
    <>
    {alertPopup && ( <CommonAlert title='Alert' message={alertMessage}/> )}
        <div className="dashboard-block">
            
                <Sidebar />
           
            <div className="dash-left">
                <Header />
                <section className="cart-block">
                <div className="container">
                    <h1 className="checkout-title">Free Code Edit</h1>  

                    <div className="right-table-outer-wrap">
                    {isLoading  ? (
                            <div className='loading-buffer'></div>
                        ):(
                            <div className='myact-wrap'>
                            <div className='client-details'>
                                <div className='form-field holiday-add-fieldset'>
                                <form className='form-field freecode-fieldset holiday-add-fieldset' onSubmit={submitButton}>
                                    <div className='input-field col-1'>
                                        <label htmlFor='name'>Code</label>
                                        <input type="text" onChange={handleChange} value={Freecode} name='Freecode' />
                                        <div style={{color:"red"}}>{errmessage.freecodeerr}</div> 
                                    </div>
                                
                                    <div className="add-free-samp-disp">
                                    
                                    <h4>Category</h4>
                                    <div className="add-free-samp-chks">
                                    {["pizza", "pasta", "burrito", "desserts"].map((category, index) => {
                                        let displayCategory = category === "pasta" ? "Pasta, Rice & Noodle Sauces" : category.charAt(0).toUpperCase() + category.slice(1);
                                       return (
                                <div className="add-check-box-wrap" key={index}>
                                    <div className="check-box">
                                        <input
                                            type="checkbox"
                                            id={`freeCat${index}`}
                                            name={category}
                                            checked={selectedCategories.includes(category)}
                                            onChange={() => handleCategoryChange(category)}
                                        />
                                        <label htmlFor={`freeCat${index}`}>{displayCategory}</label>
                                    </div>
                                    {selectedCategories.includes(category) && (
                                                                    <>
                                        <div className='switch-button-holder'>
                                            <label>Enable Add to Cart</label>
                                            <div className="switch-button">
                                                <input
                                                    type="checkbox"
                                                    className="checkbox" checked={enableAddToCart.includes(category)}
                                                    onChange={() => handleEnableAddToCart(category)}
                                                />
                                                <div className="knobs"><span></span></div>
                                                <div className="layer"></div>
                                            </div>
                                        </div>
                                                    <div className="product-list">
                                                        {groupedProducts[category]?.map((product,index) => {
                                                            const isInactive = product.PDP_Status !== "activate";
                                                            return (
                                                                <div key={product.productNumber} className="check-box">
                                                                    
                                                                        <input
                                                                            type="checkbox" id={`chkbox${category}${index}`}
                                                                            name='prd_chkbox' 
                                                                            checked={selectedProducts.includes(product.productNumber)}
                                                                            onChange={() => handleProductToggle(product.productNumber)}
                                                                            disabled={isInactive}
                                                                        />
                                                                        <label htmlFor={`chkbox${category}${index}`}>  {product.productDescription} ({product.productNumber})
                                                                    </label>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            {errmessage.categoryErr && <div className="error-msg">{errmessage.categoryErr}</div>}
                                            
                                            <div className='input-field col-1'>
                                                <label htmlFor='name'>Maximum number of products allowed in the cart</label>
                                                <select className='cartVal' value={maxProductsAllowed}
                                                        onChange={(e) => setMaxProductsAllowed(e.target.value || "0")}>
                                                    <option value="">Select value</option>
                                                    {accObjectiveoptions.map((number) => (
                                                        <option key={number} value={number}>{number}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div className='btnfield'>
                                                <button type="submit" name="btnsubmit" onClick={submitButton}>Submit</button>
                                                &nbsp;&nbsp;&nbsp;
                                                <button type="button" onClick={routeChange}>Cancel</button>
                                            </div>
                                        </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
     
        </div>
    </>
);


}
export default Freecodeedit;

  

   